import { Illustration, Typography } from "@saviynt/design-system";

interface ErrorStateProps {
  message?: string;
}

export default function ErrorState({
  message = "Something went wrong",
}: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center p-12">
      <Illustration kind="Error" />
      <Typography kind="h3" className="mt-4">
        {message}
      </Typography>
    </div>
  );
}
